// import React, { useEffect, useState } from 'react';
// import { db, auth } from '../firebase';
// import { collection, getDocs } from 'firebase/firestore';
// import { useNavigate } from 'react-router-dom';
// import Header from '../components/Header';
// import Sidebar from '../components/Sidebar';
// import '../style/Transaction.css'; // Reuse or create new CSS as needed

// const CODRemittance = () => {
//   const [summaryData, setSummaryData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const user = auth.currentUser;
//   if (!user) {
//     throw new Error("User not logged in");
//   }

//   useEffect(() => {
//     const fetchUserCodSummaries = async () => {
//       setLoading(true);
//       try {
//         const codSummaryRef = collection(db, 'users', user.uid, 'codSummary');
//         const snapshot = await getDocs(codSummaryRef);
//         const filtered = snapshot.docs
//           .map(doc => {
//             const data = doc.data();
//             return {
//               id: doc.id,
//               totalAmount: data.totalAmount,
//               lastUpdated: data.lastUpdated?.toDate().toLocaleString(),
//               status: data.status || 'pending',
//             };
//           })
//           .filter(entry => entry.status === 'confirmed');

//         setSummaryData(filtered);
//       } catch (error) {
//         console.error('Error fetching user COD summaries:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserCodSummaries();
//   }, []);

//   const handleViewDetails = (entryId) => {
//     // Pass summary ID via route or state
//     navigate(`/codsummary/details/${entryId}`);
//   };

//   return (
//     <div className="cod-summary-page">
//       <Header />
//       <div className="products-container">
//         <Sidebar />
//         <div className="main-content">
//           <h2>Your Confirmed COD Summaries</h2>
//           {loading ? (
//             <p>Loading...</p>
//           ) : summaryData.length === 0 ? (
//             <p>No confirmed COD summaries available.</p>
//           ) : (
//             <table className="cod-summary-table">
//               <thead>
//                 <tr>
//                   <th>Delivered Date</th>
//                   <th>Total Amount (₹)</th>
//                   <th>Remittance Date</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {summaryData.map((entry, index) => (
//                   <tr key={index}>
//                     <td>{entry.id}</td>
//                     <td>{entry.totalAmount?.toFixed(2) || 'NA'}</td>
//                     <td>{entry.lastUpdated || 'NA'}</td>
//                     <td>
//                       <button
//                         className="view-button"
//                         onClick={() => handleViewDetails(entry.id)}
//                       >
//                         View Details
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CODRemittance;


import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, getDoc, doc } from 'firebase/firestore';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../style/CodSummary.css';

const CodSummary = () => {
  const [summaries, setSummaries] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [orderDetails, setOrderDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const summariesPerPage = 6;

  const user = auth.currentUser;
  const userId = user?.uid;

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const codSummaryRef = collection(db, 'users', userId, 'codSummary');
        const snapshot = await getDocs(codSummaryRef);

        const filtered = [];
        for (const docSnap of snapshot.docs) {
          const data = docSnap.data();
          if (data.status === 'confirmed') {
            filtered.push({
              id: docSnap.id,
              totalAmount: data.totalAmount,
              lastUpdated: data.lastUpdated?.toDate().toLocaleString(),
              orders: data.orders || [],
              status: data.status,
            });
          }
        }

        setSummaries(filtered);
      } catch (err) {
        console.error(err);
        toast.error('Failed to load COD summaries.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  const fetchOrderDetails = async (summaryId, orders) => {
    try {
      const orderData = [];
      for (const orderId of orders) {
        const ref = doc(db, 'users', userId, 'codRecords', orderId);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          orderData.push(snap.data());
        } else {
          orderData.push({ orderId, status: 'Not Found' });
        }
      }
      setOrderDetails(prev => ({ ...prev, [summaryId]: orderData }));
    } catch (error) {
      console.error(error);
      toast.error('Error fetching order details.');
    }
  };

  const toggleDetails = async (summaryId, orders) => {
    if (expandedRow === summaryId) {
      setExpandedRow(null);
    } else {
      if (!orderDetails[summaryId]) {
        await fetchOrderDetails(summaryId, orders);
      }
      setExpandedRow(summaryId);
    }
  };

  const totalPages = Math.ceil(summaries.length / summariesPerPage);
  const paginatedSummaries = summaries.slice(
    (currentPage - 1) * summariesPerPage,
    currentPage * summariesPerPage
  );

  return (
    <div className="products-page">
      <ToastContainer />
      <Header />
      <div className="products-container">
        <Sidebar />
        <div className="main-content">
          <h2>COD Summary</h2>

          {loading ? (
            <p>Loading...</p>
          ) : paginatedSummaries.length === 0 ? (
            <p>No confirmed COD summaries found.</p>
          ) : (
            <>
              <table className="cod-summary-table">
                <thead>
                  <tr>
                    <th>Delivered Date</th>
                    <th>Total Amount</th>
                    <th>Remittance Date</th>
                    <th>Status</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedSummaries.map(summary => (
                    <React.Fragment key={summary.id}>
                      <tr>
                        <td>{summary.id}</td>
                        <td>₹{summary.totalAmount?.toFixed(2)}</td>
                        <td>{summary.lastUpdated || 'NA'}</td>
                        <td>{summary.status}</td>
                        <td>
                          <button onClick={() => toggleDetails(summary.id, summary.orders)}>
                            {expandedRow === summary.id ? 'Hide' : 'View'}
                          </button>
                        </td>
                      </tr>
                      {expandedRow === summary.id && orderDetails[summary.id] && (
                        <tr>
                          <td colSpan="5">
                            <table className="nested-details-table">
                              <thead>
                                <tr>
                                  <th>Order ID</th>
                                  <th>Amount</th>
                                  {/* <th>Status</th> */}
                                  {/* <th>Date</th> */}
                                  <th>Timestamp</th>
                                </tr>
                              </thead>
                              <tbody>
                                {orderDetails[summary.id].map((order, idx) => (
                                  <tr key={idx}>
                                    <td>{order.orderId || 'NA'}</td>
                                    <td>{order.amount || 'NA'}</td>
                                    {/* <td>{order.status || 'NA'}</td> */}
                                    {/* <td>{order.date || 'NA'}</td> */}
                                    <td>
                                      {order.timestamp
                                        ? new Date(order.timestamp.seconds * 1000).toLocaleString()
                                        : 'NA'}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>

              <div className="pagination">
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i + 1}
                    className={currentPage === i + 1 ? 'active' : ''}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CodSummary;



// import React, { useState, useEffect } from 'react';
// import {
//   collection,
//   getDocs,
//   doc,
//   getDoc,
//   query,
//   orderBy
// } from 'firebase/firestore';
// import { db, auth } from '../firebase';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import '../style/CodSummary.css'; // Make sure this file exists and has the styles

// const CodSummary = () => {
//   const [summaryData, setSummaryData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [expandedRow, setExpandedRow] = useState(null);
//   const [orderDetails, setOrderDetails] = useState({});
//   const [selectedSummary, setSelectedSummary] = useState(null);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const summariesPerPage = 5;

//   const fetchCodSummaries = async () => {
//     setLoading(true);
//     try {
//       const user = auth.currentUser;
//       if (!user) throw new Error('User not authenticated.');

//       const userId = user.uid;
//       const codSummaryRef = collection(db, 'users', userId, 'codSummary');
//       const q = query(codSummaryRef, orderBy('lastUpdated', 'desc'));
//       const codSummarySnapshot = await getDocs(q);

//       const allSummaries = [];

//       for (const docSnap of codSummarySnapshot.docs) {
//         const data = docSnap.data();
//         if (data.status === 'confirmed') {
//           allSummaries.push({
//             id: docSnap.id,
//             date: docSnap.id,
//             totalAmount: data.totalAmount,
//             lastUpdated: data.lastUpdated?.toDate().toLocaleString(),
//             status: data.status,
//             orders: data.orders || []
//           });
//         }
//       }

//       setSummaryData(allSummaries);
//     } catch (error) {
//       console.error('Error fetching COD summaries:', error);
//       toast.error('Failed to fetch COD summary data.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchOrderDetails = async (summary) => {
//     try {
//       const user = auth.currentUser;
//       if (!user) throw new Error('User not authenticated.');

//       const userId = user.uid;
//       const codRecordsRef = collection(db, 'users', userId, 'codRecords');
//       const fetchedOrders = [];

//       for (const orderId of summary.orders) {
//         const orderDoc = await getDoc(doc(codRecordsRef, orderId));
//         if (orderDoc.exists()) {
//           fetchedOrders.push(orderDoc.data());
//         }
//       }

//       setOrderDetails((prev) => ({ ...prev, [summary.id]: fetchedOrders }));
//       setExpandedRow(summary.id);
//       setSelectedSummary(summary);
//     } catch (error) {
//       console.error('Error fetching order details:', error);
//       toast.error('Failed to fetch order details.');
//     }
//   };

//   useEffect(() => {
//     fetchCodSummaries();
//   }, []);

//   // Pagination logic
//   const indexOfLastSummary = currentPage * summariesPerPage;
//   const indexOfFirstSummary = indexOfLastSummary - summariesPerPage;
//   const currentSummaries = summaryData.slice(indexOfFirstSummary, indexOfLastSummary);
//   const totalPages = Math.ceil(summaryData.length / summariesPerPage);

//   return (
//     <div className="cod-summary-page">
//       <ToastContainer position="top-center" autoClose={5000} hideProgressBar />
//       <h2>COD Summary</h2>

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <>
//           <table className="cod-summary-table">
//             <thead>
//               <tr>
//                 <th>Delivered Date</th>
//                 <th>Total Amount (₹)</th>
//                 <th>Remittance Date</th>
//                 <th>Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentSummaries.length > 0 ? (
//                 currentSummaries.map((summary) => (
//                   <tr key={summary.id}>
//                     <td>{summary.date}</td>
//                     <td>{summary.totalAmount?.toFixed(2) || 'NA'}</td>
//                     <td>{summary.lastUpdated || 'NA'}</td>
//                     <td>{summary.status || 'NA'}</td>
//                     <td>
//                       <button onClick={() => fetchOrderDetails(summary)}>View Details</button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5">No confirmed COD summary data available.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>

//           {/* Pagination Controls */}
//           <div className="pagination">
//             {Array.from({ length: totalPages }, (_, index) => (
//               <button
//                 key={index + 1}
//                 onClick={() => setCurrentPage(index + 1)}
//                 className={currentPage === index + 1 ? 'active' : ''}
//               >
//                 {index + 1}
//               </button>
//             ))}
//           </div>

//           {/* Modal for Order Details */}
//           {expandedRow === selectedSummary?.id && orderDetails[selectedSummary?.id] && (
//             <div className="modal-overlay">
//               <div className="modal-content">
//                 <button className="modal-close" onClick={() => setExpandedRow(null)}>×</button>
//                 <h3>Order Details for {selectedSummary.date}</h3>
//                 <table className="nested-details-table">
//                   <thead>
//                     <tr>
//                       <th>Order ID</th>
//                       <th>Amount</th>
//                       <th>Status</th>
//                       <th>Date</th>
//                       <th>Timestamp</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {orderDetails[selectedSummary.id].map((order, idx) => (
//                       <tr key={idx}>
//                         <td>{order.orderId || 'NA'}</td>
//                         <td>{order.amount || 'NA'}</td>
//                         <td>{order.status || 'NA'}</td>
//                         <td>{order.date || 'NA'}</td>
//                         <td>
//                           {order.timestamp
//                             ? new Date(order.timestamp.seconds * 1000).toLocaleString()
//                             : 'NA'}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default CodSummary;
